var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.815013V19.1095C0.00260239 19.2555 0.0420995 19.3982 0.114509 19.5232C0.186918 19.6482 0.289678 19.7511 0.41243 19.8215C0.535182 19.8919 0.673585 19.9274 0.813683 19.9243C0.953782 19.9212 1.09062 19.8797 1.21041 19.8039L15.564 10.6567C15.6786 10.5844 15.7734 10.4825 15.8392 10.3608C15.905 10.2392 15.9396 10.1019 15.9396 9.96225C15.9396 9.82261 15.905 9.68532 15.8392 9.56367C15.7734 9.44202 15.6786 9.34011 15.564 9.2678L1.21041 0.120561C1.09062 0.0447922 0.953782 0.00327149 0.813683 0.000185533C0.673585 -0.00290042 0.535182 0.0325577 0.41243 0.102984C0.289678 0.173411 0.186918 0.276317 0.114509 0.401325C0.0420995 0.526333 0.00260239 0.669025 0 0.815013Z",
    fill: "var(--fill-0, #D9D9D9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowVector);
export default __webpack_public_path__ + "static/media/arrow-vector.305aa60aec3833be69ee07743a3c848a.svg";
export { ForwardRef as ReactComponent };